function assetUrl(n) {
  try { return (window.__assets && window.__assets[n]) || n; } catch (e) { return n; }
}
    function updateClock() {
      const now = new Date();
      const h = String(now.getUTCHours()).padStart(2, '0');
      const m = String(now.getUTCMinutes()).padStart(2, '0');
      const s = String(now.getUTCSeconds()).padStart(2, '0');
      const clockEl = document.getElementById('clock-display');
      if (clockEl) clockEl.textContent = `${h}:${m}:${s} UTC`;
    }
    setInterval(updateClock, 1000);
    updateClock();

    function scrollToSection(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }

    function toggleMobileMenu(forceState) {
      const overlay = document.getElementById('mobile-menu-overlay');
      const btn = document.getElementById('menu-toggle-btn');
      if (!overlay) return;
      let opened;
      if (typeof forceState === 'boolean') {
        overlay.classList.toggle('open', forceState);
        opened = forceState;
      } else {
        opened = overlay.classList.toggle('open');
      }
      if (btn) btn.textContent = opened ? 'CLOSE ✕' : 'MENU';
    }

    let cartItems = [
      { id: 1, name: 'ASCENSION HEAVY HOODIE', price: 165, size: 'L', qty: 1, img: assetUrl('cutout_1.png') }
    ];

    function toggleCartDrawer(open) {
      const overlay = document.getElementById('cart-overlay');
      const drawer = document.getElementById('cart-drawer');
      if (open) {
        overlay.classList.add('open');
        drawer.classList.add('open');
      } else {
        overlay.classList.remove('open');
        drawer.classList.remove('open');
      }
    }

    function renderCart() {
      const container = document.getElementById('cart-items-container');
      const subtotalEl = document.getElementById('cart-subtotal-text');
      const bagHeader = document.getElementById('header-bag-count');
      const bagMobile = document.getElementById('mobile-bag-count');
      const cartCount = document.getElementById('cart-item-count');

      let totalQty = 0;
      let totalSum = 0;

      container.innerHTML = '';
      cartItems.forEach((item, index) => {
        totalQty += item.qty;
        totalSum += item.price * item.qty;

        const itemEl = document.createElement('div');
        itemEl.className = 'cart-item';
        itemEl.innerHTML = `
          <img class="cart-item-img" src="${assetUrl(item.img)}" alt="${item.name}">
          <div class="cart-item-details">
            <div class="cart-item-name">${item.name}</div>
            <div class="cart-item-variant">SIZE: ${item.size} // 480GSM COTTON</div>
            <div class="cart-item-row">
              <div class="cart-qty-ctrl">
                <button class="qty-btn" onclick="updateItemQty(${index}, -1)">−</button>
                <span>${item.qty}</span>
                <button class="qty-btn" onclick="updateItemQty(${index}, 1)">+</button>
              </div>
              <span class="cart-item-price">$${item.price * item.qty}</span>
            </div>
          </div>
        `;
        container.appendChild(itemEl);
      });

      if (cartItems.length === 0) {
        container.innerHTML = `<div style="text-align:center; padding:40px; color:#888;">YOUR BAG IS EMPTY.</div>`;
      }

      subtotalEl.textContent = `$${totalSum} USD`;
      if (bagHeader) bagHeader.textContent = totalQty;
      if (bagMobile) bagMobile.textContent = totalQty;
      if (cartCount) cartCount.textContent = totalQty;
    }

    function addItemToCart(name, price, size, img) {
      const existing = cartItems.find(i => i.name === name && i.size === size);
      if (existing) {
        existing.qty++;
      } else {
        cartItems.push({ id: Date.now(), name, price, size, qty: 1, img });
      }
      renderCart();
      toggleCartDrawer(true);
    }

    function updateItemQty(index, delta) {
      if (!cartItems[index]) return;
      cartItems[index].qty += delta;
      if (cartItems[index].qty <= 0) cartItems.splice(index, 1);
      renderCart();
    }
    renderCart();

    let totalSeconds = (function() {
      const v = document.getElementById('vault');
      const n = v && v.dataset ? parseInt(v.dataset.countdown, 10) : NaN;
      return Number.isFinite(n) ? n : 305409;
    })();
    function updateCountdown() {
      totalSeconds = Math.max(0, totalSeconds - 1);
      const d = Math.floor(totalSeconds / 86400);
      const h = Math.floor((totalSeconds % 86400) / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;

      const dEl = document.getElementById('timer-days');
      const hEl = document.getElementById('timer-hours');
      const mEl = document.getElementById('timer-mins');
      const sEl = document.getElementById('timer-secs');

      if (dEl) dEl.textContent = `${String(d).padStart(2,'0')}D`;
      if (hEl) hEl.textContent = `${String(h).padStart(2,'0')}H`;
      if (mEl) mEl.textContent = `${String(m).padStart(2,'0')}M`;
      if (sEl) sEl.textContent = `${String(s).padStart(2,'0')}S`;
    }
    setInterval(updateCountdown, 1000);

    function selectCollection(category, label) {
      const filterBtn = document.getElementById(`btn-filter-${category}`);
      filterVault(category, filterBtn, label);
      scrollToSection('vault');
    }

    function resetVaultFilter() {
      const btnAll = document.getElementById('btn-filter-all');
      filterVault('all', btnAll, 'ALL ARCHIVE PRODUCTS (08)');
    }

    function filterVault(category, btn, customLabel) {
      document.querySelectorAll('.filter-pill').forEach(b => b.classList.remove('active'));
      if (btn) btn.classList.add('active');

      const labelEl = document.getElementById('active-collection-label');
      if (labelEl) {
        if (customLabel) {
          labelEl.textContent = customLabel;
        } else if (category === 'all') {
          labelEl.textContent = 'ALL ARCHIVE PRODUCTS (08)';
        } else if (category === 'hoodies') {
          labelEl.textContent = '🔥 480GSM HEAVYWEIGHT HOODIES & CREWS';
        } else if (category === 'summer') {
          labelEl.textContent = '☀️ SUMMER CYPHER COLLECTION (BOXY TEES)';
        } else if (category === 'pants') {
          labelEl.textContent = '⚡ TACTICAL TECHWEAR (CARGOS & OUTERWEAR)';
        } else if (category === 'headwear') {
          labelEl.textContent = '🎮 VR ERGONOMIC HEADWEAR & ACCESSORIES';
        }
      }

      const cards = document.querySelectorAll('.vault-card');
      cards.forEach(card => {
        if (category === 'all' || card.dataset.category === category) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
    }

    let currentPdp = { name: '', price: 0, img: '', size: 'L', desc: '' };
    function openPdpModal(name, price, img, desc) {
      currentPdp = { name, price, img, size: 'L', desc };
      document.getElementById('pdp-title').textContent = name;
      document.getElementById('pdp-price').textContent = `$${price} USD`;
      document.getElementById('pdp-img').src = assetUrl(img);
      document.getElementById('pdp-desc').textContent = desc;
      document.getElementById('pdp-btn-price').textContent = `$${price}`;
      document.getElementById('pdp-modal-overlay').classList.add('open');
    }

    function closePdpModal() {
      document.getElementById('pdp-modal-overlay').classList.remove('open');
    }
    function closePdpModalOnOverlay(e) {
      if (e.target.id === 'pdp-modal-overlay') closePdpModal();
    }

    function selectPdpSize(size, btn) {
      document.querySelectorAll('.size-opt-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      currentPdp.size = size;
      document.getElementById('pdp-selected-size-text').textContent = size;
    }

    function addPdpToCart() {
      addItemToCart(currentPdp.name, currentPdp.price, currentPdp.size, currentPdp.img);
      closePdpModal();
    }

    function switchStudioPillar(index, btn) {
      document.querySelectorAll('.studio-tab-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    }

    let selectedPreferences = ['480GSM Heavy Hoodies', 'Summer Cypher Tees', '15-Min Early Secret Window'];
    function togglePrefChip(chip, text) {
      chip.classList.toggle('selected');
      const isSelected = chip.classList.contains('selected');
      if (isSelected) {
        if (!selectedPreferences.includes(text)) selectedPreferences.push(text);
        if (!chip.textContent.startsWith('✓')) chip.textContent = '✓ ' + chip.textContent.replace('+', '').trim();
      } else {
        selectedPreferences = selectedPreferences.filter(item => item !== text);
        chip.textContent = '+ ' + chip.textContent.replace('✓', '').trim();
      }

      const feedbackEl = document.getElementById('terminal-feedback-text');
      if (selectedPreferences.length === 0) {
        feedbackEl.textContent = 'PLEASE CLICK TO SELECT YOUR DROP INTERESTS ABOVE.';
      } else {
        feedbackEl.textContent = `CONFIGURED FOR: ${selectedPreferences.join(', ')}.`;
      }
    }

    function handleTerminalSubmit(e) {
      e.preventDefault();
      const email = document.getElementById('terminal-email-input').value;
      const submitBtn = document.getElementById('terminal-submit-btn');
      const feedbackBanner = document.getElementById('terminal-feedback');

      submitBtn.textContent = 'ACCESS GRANTED ✓';
      submitBtn.style.background = '#22C55E';
      submitBtn.style.color = '#000';

      feedbackBanner.style.background = 'rgba(34, 197, 94, 0.15)';
      feedbackBanner.style.borderColor = '#22C55E';
      document.getElementById('terminal-feedback-text').innerHTML = `
        <strong style="color:#22C55E;">VIP PASS ACTIVATED:</strong> Encrypted key sent to <strong>${email}</strong> for [${selectedPreferences.join(', ')}].
      `;
    }

    function handleMacroZoom(e) {
      const wrap = document.getElementById('macro-canvas');
      const reticle = document.getElementById('macro-reticle');
      const lens = document.getElementById('macro-lens');
      const rect = wrap.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      reticle.style.left = `${x}px`;
      reticle.style.top = `${y}px`;

      lens.style.display = 'block';
      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;
      lens.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    }

    function hideMacroLens() {
      const lens = document.getElementById('macro-lens');
      if (lens) lens.style.display = 'none';
    }

    function switchSpecTab(index, card) {
      document.querySelectorAll('.spec-tab-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      const img = card.dataset.img || 'cutout_1.png';
      const reticle = card.dataset.reticle || '480GSM';

      document.getElementById('macro-img').src = assetUrl(img);
      document.getElementById('macro-lens').style.backgroundImage = `url('${assetUrl(img)}')`;
      document.getElementById('macro-reticle').textContent = reticle;
    }

    const sizeData = {
      cm: [
        { size: 'S', chest: '118', length: '70', shoulder: '56', sleeve: '58' },
        { size: 'M', chest: '124', length: '73', shoulder: '58', sleeve: '60' },
        { size: 'L', chest: '130', length: '76', shoulder: '61', sleeve: '62' },
        { size: 'XL', chest: '136', length: '79', shoulder: '64', sleeve: '64' },
        { size: '2XL', chest: '142', length: '82', shoulder: '67', sleeve: '66' }
      ],
      in: [
        { size: 'S', chest: '46.5', length: '27.5', shoulder: '22.0', sleeve: '22.8' },
        { size: 'M', chest: '48.8', length: '28.7', shoulder: '22.8', sleeve: '23.6' },
        { size: 'L', chest: '51.2', length: '29.9', shoulder: '24.0', sleeve: '24.4' },
        { size: 'XL', chest: '53.5', length: '31.1', shoulder: '25.2', sleeve: '25.2' },
        { size: '2XL', chest: '55.9', length: '32.3', shoulder: '26.4', sleeve: '26.0' }
      ]
    };

    let currentSizeUnit = 'cm';
    function renderSizeTable() {
      const table = document.getElementById('size-table-body');
      const data = sizeData[currentSizeUnit];
      table.innerHTML = `
        <thead>
          <tr>
            <th>SIZE</th>
            <th>CHEST (${currentSizeUnit.toUpperCase()})</th>
            <th>LENGTH</th>
            <th>SHOULDER</th>
            <th>SLEEVE</th>
          </tr>
        </thead>
        <tbody>
          ${data.map(row => `
            <tr>
              <td><strong>${row.size}</strong></td>
              <td>${row.chest}</td>
              <td>${row.length}</td>
              <td>${row.shoulder}</td>
              <td>${row.sleeve}</td>
            </tr>
          `).join('')}
        </tbody>
      `;
    }

    function switchSizeUnit(unit) {
      currentSizeUnit = unit;
      document.getElementById('unit-cm-btn').classList.toggle('active', unit === 'cm');
      document.getElementById('unit-in-btn').classList.toggle('active', unit === 'in');
      renderSizeTable();
    }

    function openSizeChartModal() {
      renderSizeTable();
      document.getElementById('size-modal-overlay').classList.add('open');
    }
    function closeSizeModal() {
      document.getElementById('size-modal-overlay').classList.remove('open');
    }
    function closeSizeModalOnOverlay(e) {
      if (e.target.id === 'size-modal-overlay') closeSizeModal();
    }

    function toggleFaq(btn) {
      const item = btn.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    }

    
    
    
    
    
    
    
    // =========================================================================
    // ADVANCED AUTOPLAY BILLBOARD RAP ENGINE (WEB AUDIO + GESTURE CAPTURE)
    // =========================================================================
    const billboardRapTracks = [
      { "title": "Not Like Us", "artist": "Kendrick Lamar", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/b6/6b/8c/b66b8c42-8c82-242b-4ef1-3655d19ac1aa/mzaf_1950801191699299821.plus.aac.p.m4a" },
      { "title": "FE!N", "artist": "Travis Scott", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview116/v4/85/82/96/8582960b-2b19-b1eb-8179-b03be49f332b/mzaf_10214925442893249225.plus.aac.p.m4a" },
      { "title": "squabble up", "artist": "Kendrick Lamar", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/91/e5/aa/91e5aa0f-5d8b-532f-8a72-23d4f721d847/mzaf_14650418192241940161.plus.aac.p.m4a" },
      { "title": "luther", "artist": "Kendrick Lamar", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/e0/1d/98/e01d9881-0953-f0ed-b03d-3a4bd6f3c769/mzaf_8283505998481315852.plus.aac.p.m4a" },
      { "title": "Type Shit", "artist": "Future & Metro Boomin", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/00/7c/e2/007ce23b-3768-16d5-5036-399264a73055/mzaf_13283247960348749358.plus.aac.p.m4a" },
      { "title": "Like That", "artist": "Future & Metro Boomin", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/50/b7/9c/50b79cb8-820b-96d5-6612-70aed1e70687/mzaf_16512581449648931374.plus.aac.p.m4a" },
      { "title": "First Person Shooter", "artist": "Drake ft. J. Cole", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/4c/d1/ec/4cd1ec67-7497-2cc5-2099-e8371ee61d98/mzaf_8426087503690349668.plus.aac.p.m4a" },
      { "title": "BANDIT", "artist": "Don Toliver", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/a0/32/00/a0320028-02bd-feb1-644d-2937907c41b0/mzaf_1316463978077053807.plus.aac.p.m4a" },
      { "title": "TORE UP", "artist": "Don Toliver", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/0e/d1/69/0ed16941-76d9-1300-3da1-e0492f3991a8/mzaf_771535588021638781.plus.aac.p.m4a" },
      { "title": "redrum", "artist": "21 Savage", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview126/v4/63/ad/85/63ad85d5-8b49-520f-0f73-1cdc0ed9a80e/mzaf_16051919311495206574.plus.aac.p.m4a" },
      { "title": "BUTTERFLY EFFECT", "artist": "Travis Scott", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview125/v4/50/de/cf/50decf79-548e-cb82-d9c3-389b805f3d99/mzaf_12127657751890989044.plus.aac.p.m4a" },
      { "title": "Houdini", "artist": "Eminem", "url": "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/06/84/7c/06847cab-2fde-ea27-d995-45df7ff39d37/mzaf_2399672252860451236.plus.aac.p.m4a" }
    ];

    // Single Global Audio Player
    const billboardAudio = new Audio();
    billboardAudio.volume = 0.85;
    billboardAudio.preload = 'auto';

    let currentRapIndex = -1;
    let isRapActive = false;
    let userManuallyPaused = false;
    let audioCtx = null;

    function getNextRandomIndex() {
      let nextIdx;
      do {
        nextIdx = Math.floor(Math.random() * billboardRapTracks.length);
      } while (nextIdx === currentRapIndex && billboardRapTracks.length > 1);
      return nextIdx;
    }

    function initAudioContext() {
      if (!audioCtx) {
        try {
          const AudioContext = window.AudioContext || window.webkitAudioContext;
          if (AudioContext) audioCtx = new AudioContext();
        } catch(e) {}
      }
      if (audioCtx && audioCtx.state === 'suspended') {
        audioCtx.resume().catch(() => {});
      }
    }

    function playTrack(idx) {
      try {
        billboardAudio.pause();
        billboardAudio.currentTime = 0;
      } catch(e) {}

      initAudioContext();
      currentRapIndex = idx >= 0 ? idx : getNextRandomIndex();
      const track = billboardRapTracks[currentRapIndex];
      billboardAudio.src = track.url;
      billboardAudio.currentTime = 0;

      const btn = document.getElementById('beat-player-btn');
      const statusText = document.getElementById('beat-status-text');
      const label = `▶ ${track.title.toUpperCase()} — ${track.artist.toUpperCase()}`;

      const playPromise = billboardAudio.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          isRapActive = true;
          if (btn) btn.classList.add('playing');
          if (statusText) statusText.textContent = label;
          hideSoundBanner();
        }).catch(err => {
          // Browser Autoplay Policy: start immediately on any first gesture
          isRapActive = false;
          if (btn) btn.classList.remove('playing');
          if (statusText) statusText.textContent = label;
          showSoundBanner();
        });
      }
    }

    function showSoundBanner() {
      let b = document.getElementById('cyber-sound-banner');
      if (!b) {
        b = document.createElement('div');
        b.id = 'cyber-sound-banner';
        b.innerHTML = '<span style="color:#FF2222; font-weight:900; margin-right:6px;">⚡ CYPHER AUDIO READY:</span> TAP ANYWHERE TO ACTIVATE SOUND ▶';
        b.setAttribute('style', 'position:fixed; bottom:24px; right:24px; z-index:99999; background:rgba(10,10,14,0.95); border:1px solid #FF2222; color:#fff; font-family:monospace; font-size:11px; padding:10px 18px; border-radius:100px; box-shadow:0 0 25px rgba(255,34,34,0.4); cursor:pointer; letter-spacing:0.1em; transition:opacity 0.3s ease; animation:pulseGlow 1.5s infinite;');
        b.onclick = () => { triggerImmediatePlay(); };
        document.body.appendChild(b);
      }
      b.style.display = 'block';
      b.style.opacity = '1';
    }

    function hideSoundBanner() {
      const b = document.getElementById('cyber-sound-banner');
      if (b) {
        b.style.opacity = '0';
        setTimeout(() => { if (b) b.style.display = 'none'; }, 300);
      }
    }

    function triggerImmediatePlay() {
      initAudioContext();
      if (billboardAudio.paused) {
        userManuallyPaused = false;
        playTrack(currentRapIndex >= 0 ? currentRapIndex : getNextRandomIndex());
      }
      hideSoundBanner();
    }

    // When song naturally finishes, auto play next
    billboardAudio.onended = function() {
      if (isRapActive) {
        playTrack(getNextRandomIndex());
      }
    };

    // Button click handler
    function toggleBillboardRap() {
      initAudioContext();
      const btn = document.getElementById('beat-player-btn');
      const statusText = document.getElementById('beat-status-text');

      if (isRapActive && !billboardAudio.paused) {
        // STOP AUDIO COMPLETELY
        isRapActive = false;
        userManuallyPaused = true;
        billboardAudio.pause();
        billboardAudio.currentTime = 0;
        if (btn) btn.classList.remove('playing');
        if (statusText) statusText.textContent = 'BILLBOARD RAP // PAUSED';
      } else {
        // START A BRAND NEW RANDOM SONG
        userManuallyPaused = false;
        playTrack(getNextRandomIndex());
      }
    }

    // 1. Attempt immediate autoplay on cold load
    playTrack(getNextRandomIndex());

    // 2. High-speed Capture Listeners on entire window & document:
    // Any click, tap, keypress or pointerdown on ANY element in the whole page instantly unlocks audio
    const unlockAudioCapture = (e) => {
      if (userManuallyPaused) return;
      if (billboardAudio.paused) {
        triggerImmediatePlay();
      }
    };

    ['pointerdown', 'touchstart', 'mousedown', 'click', 'keydown'].forEach(evt => {
      window.addEventListener(evt, unlockAudioCapture, { capture: true, passive: true, once: false });
      document.addEventListener(evt, unlockAudioCapture, { capture: true, passive: true, once: false });
    });

    // MOTION SITES SCROLL-TO-VIDEO SCRUB ENGINE
    const video = document.getElementById('bg-video');
    const heroTitle = document.getElementById('bottom-title-container');
    const sliderOverlay = document.getElementById('product-slider-overlay');
    const sliderTrack = document.getElementById('product-slider-track');
    const sliderSymbol = document.getElementById('slider-symbol');
    const parallaxItems = document.querySelectorAll('.parallax-item');
    const sliderCards = document.querySelectorAll('.slider-product-card');

    const symbols = ['◇', '≠', '↟', '✦', '⊹', '∧', '⟡', '∴', '⟶', '∿', '⬡'];
    let lastCardIndex = -1;

    let currentScroll = 0;
    let smoothScroll = 0;

    function primeVideo() {
      if (video) {
        video.play().then(() => video.pause()).catch(() => {});
      }
    }
    window.addEventListener('load', primeVideo);
    window.addEventListener('touchstart', primeVideo, { once: true });
    window.addEventListener('click', primeVideo, { once: true });

    window.addEventListener('scroll', () => {
      currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    }, { passive: true });

    function animate() {
      smoothScroll += (currentScroll - smoothScroll) * 0.12;

      const viewportH = window.innerHeight;
      const heroSpacerH = viewportH * 2.5;

      if (video && video.duration && !isNaN(video.duration)) {
        const heroProgress = Math.max(0, Math.min(1, smoothScroll / heroSpacerH));
        const targetTime = heroProgress * video.duration;
        
        if (!video.seeking && Math.abs(video.currentTime - targetTime) > 0.03) {
          video.currentTime = targetTime;
        }
      }

      if (heroTitle) {
        const tProgress = Math.max(0, Math.min(1, smoothScroll / (heroSpacerH * 0.75)));
        const translateY = -120 * tProgress;
        const scale = 1 - (0.15 * tProgress);
        const opacity = tProgress > 0.25 ? Math.max(0, 1 - ((tProgress - 0.25) / 0.6)) : 1;
        const blurPx = tProgress * 20;

        heroTitle.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;
        heroTitle.style.opacity = opacity;
        heroTitle.style.filter = `blur(${blurPx}px)`;
        heroTitle.style.visibility = opacity <= 0.01 ? 'hidden' : 'visible';
      }

      const manifestoSec = document.querySelector('.streetwear-manifesto-section');
      if (manifestoSec) {
        const rect = manifestoSec.getBoundingClientRect();
        const secCenter = rect.top + rect.height / 2;
        const viewCenter = viewportH / 2;
        const normDist = (viewCenter - secCenter) / (viewportH * 0.8);

        parallaxItems.forEach(item => {
          const speed = parseFloat(item.dataset.speed || 0.2);
          const drift = parseFloat(item.dataset.drift || 0.1);
          const rot = parseFloat(item.dataset.rot || 0.5);

          const yOff = normDist * speed * 380;
          const xOff = normDist * drift * 380;
          const rOff = normDist * rot * 6;

          item.style.transform = `translate3d(${xOff}px, ${yOff}px, 0) rotate(${rOff}deg)`;
        });
      }

      const sliderSpacer = document.getElementById('loop-scroll-spacer');
      if (sliderSpacer && sliderOverlay && sliderTrack) {
        const spacerRect = sliderSpacer.getBoundingClientRect();
        const spacerTop = spacerRect.top;
        const spacerTotal = sliderSpacer.offsetHeight - viewportH;

        if (spacerTop <= 0 && spacerTop >= -spacerTotal) {
          sliderOverlay.classList.add('active');
          const sliderProgress = Math.max(0, Math.min(1, -spacerTop / spacerTotal));

          const clipProgress = Math.min(1, sliderProgress / 0.25);
          const easedClip = clipProgress < 0.5 
            ? 4 * clipProgress * clipProgress * clipProgress 
            : 1 - Math.pow(-2 * clipProgress + 2, 3) / 2;
          
          const insetVal = (1 - easedClip) * 50;
          sliderOverlay.style.clipPath = `inset(${insetVal}% ${insetVal}% ${insetVal}% ${insetVal}% round 4px)`;
          sliderOverlay.style.webkitClipPath = `inset(${insetVal}% ${insetVal}% ${insetVal}% ${insetVal}% round 4px)`;

          const swipeProgress = Math.max(0, (sliderProgress - 0.25) / 0.75);
          const totalCards = sliderCards.length;
          const maxTranslate = (totalCards - 1) * 100;
          const currentTranslate = swipeProgress * maxTranslate;

          sliderTrack.style.transform = `translate3d(-${currentTranslate}vw, 0, 0)`;

          sliderCards.forEach((card, idx) => {
            const cardImg = card.querySelector('.slider-card-bg-img');
            if (cardImg) {
              const cardOffset = (swipeProgress * (totalCards - 1)) - idx;
              cardImg.style.transform = `translate3d(${cardOffset * 18}%, 0, 0)`;
            }
          });

          const activeCardIdx = Math.min(totalCards - 1, Math.round(swipeProgress * (totalCards - 1)));
          if (activeCardIdx !== lastCardIndex) {
            lastCardIndex = activeCardIdx;
            if (sliderSymbol) {
              sliderSymbol.style.opacity = '0';
              sliderSymbol.style.transform = 'translate(-50%, -50%) scale(0.85)';
              setTimeout(() => {
                sliderSymbol.textContent = symbols[activeCardIdx % symbols.length];
                sliderSymbol.style.opacity = '0.10';
                sliderSymbol.style.transform = 'translate(-50%, -50%) scale(1)';
              }, 150);
            }
          }
        } else if (spacerTop > 0) {
          sliderOverlay.classList.remove('active');
          sliderOverlay.style.clipPath = `inset(50% 50% 50% 50%)`;
          sliderOverlay.style.webkitClipPath = `inset(50% 50% 50% 50%)`;
        } else {
          sliderOverlay.classList.remove('active');
        }
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
// Product page gallery + size pills (main-product section)
function switchImage(src, el) {
  var hero = document.getElementById('pdp-hero-img');
  if (hero) hero.src = src;
  document.querySelectorAll('.pdp-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (el) el.classList.add('active');
}
function selectSize(title, el) {
  document.querySelectorAll('.size-pill').forEach(function(p) { p.classList.remove('active'); });
  if (el) el.classList.add('active');
}

// Brand video player controls (custom-video-player section)
function switchVideoAspect(aspect, btn) {
  document.querySelectorAll('.aspect-btn').forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');
  var wrap = document.getElementById('brand-video-wrap');
  var label = document.getElementById('current-aspect-label');
  if (!wrap) return;
  if (aspect === '16/9') { wrap.style.aspectRatio = '16 / 9'; wrap.style.maxWidth = '1000px'; if (label) label.textContent = '16:9 WIDESCREEN'; }
  else if (aspect === '3/4') { wrap.style.aspectRatio = '3 / 4'; wrap.style.maxWidth = '560px'; if (label) label.textContent = '3:4 EDITORIAL PORTRAIT'; }
  else if (aspect === '1/1') { wrap.style.aspectRatio = '1 / 1'; wrap.style.maxWidth = '640px'; if (label) label.textContent = '1:1 SQUARE'; }
  else if (aspect === '9/16') { wrap.style.aspectRatio = '9 / 16'; wrap.style.maxWidth = '420px'; if (label) label.textContent = '9:16 VERTICAL REEL'; }
}
function toggleBrandVideoPlay() {
  var vid = document.getElementById('brand-video-player');
  var btn = document.getElementById('video-play-btn');
  if (!vid) return;
  if (vid.paused) { vid.play(); if (btn) btn.textContent = '❚❚ PAUSE'; }
  else { vid.pause(); if (btn) btn.textContent = '▶ PLAY'; }
}
function toggleBrandVideoMute() {
  var vid = document.getElementById('brand-video-player');
  var btn = document.getElementById('video-mute-btn');
  if (!vid) return;
  vid.muted = !vid.muted;
  if (btn) btn.textContent = vid.muted ? '🔇 UNMUTE' : '🔊 MUTE';
}
